/**
 * @generated SignedSource<<bce061a37870779f5d423c543bb5ec00>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedCondensedSidebarButtons_displayInfo$data = {
  readonly ctas: {
    readonly showAcceptOffer: boolean | null;
    readonly showFollowCategory: boolean | null;
    readonly showMakeOffer: boolean | null;
    readonly showPurchase: boolean | null;
    readonly showRequestPrice: boolean | null;
  } | null;
  readonly " $fragmentType": "PdpSharedCondensedSidebarButtons_displayInfo";
};
export type PdpSharedCondensedSidebarButtons_displayInfo$key = {
  readonly " $data"?: PdpSharedCondensedSidebarButtons_displayInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedCondensedSidebarButtons_displayInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedCondensedSidebarButtons_displayInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CTADisplay",
      "kind": "LinkedField",
      "name": "ctas",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showAcceptOffer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showPurchase",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showMakeOffer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showFollowCategory",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showRequestPrice",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemDisplayInfo",
  "abstractKey": null
};

(node as any).hash = "12d6b1ce9990c3cebc82283e9bfef935";

export default node;
